// Next
import Script from "next/script";

const GlobalWkPageData = () => {
    const scriptContent = `
        // Global wkPageData data layer   
        var wkPageData = window.wkPageData || {};    
        wkPageData.page = {
            "pageInfo": {
                "pageID": "",
                "pageTitle": ""
            },
            "category": {
                "businessUnit": "LR - Europe - Italy",
                 "division": "LR" 
            },
            "attributes": {
                "pageTemplate": "",
                "pageLanguage": "it-it",
                "solution": "",
                "solutionSuite": "",
                "solutionHub": "",
                "funnelStage": ""
            }
        };`;

    return <Script id={"wkpagedata-script"} dangerouslySetInnerHTML={{__html: scriptContent}} strategy={"beforeInteractive"}/>
};

export default GlobalWkPageData;
